import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
} from '../constants/geoSwitcher';

const SUBDOMAIN_FAMILY_PAIRS: Record<number, number> = {
  [MOSCOW_REGION_ID]: MOSCOW_AREA_REGION_ID,
  [MOSCOW_AREA_REGION_ID]: MOSCOW_REGION_ID,
  [ST_PETERSBURG_REGION_ID]: ST_PETERSBURG_AREA_REGION_ID,
  [ST_PETERSBURG_AREA_REGION_ID]: ST_PETERSBURG_REGION_ID,
};

interface ISubdomainRegion {
  id: number;
  parentId?: number | null;
  mainTownId?: number | null;
}

export function isRegionInSubdomainFamily(
  cookieRegionId: number | null | undefined,
  subdomainRegion: ISubdomainRegion | null | undefined,
): boolean {
  if (cookieRegionId == null || !subdomainRegion) {
    return false;
  }

  if (
    cookieRegionId === subdomainRegion.id ||
    cookieRegionId === subdomainRegion.parentId ||
    cookieRegionId === subdomainRegion.mainTownId
  ) {
    return true;
  }

  return SUBDOMAIN_FAMILY_PAIRS[subdomainRegion.id] === cookieRegionId;
}
